module.exports = __webpack_public_path__ + "./JanePhoto_8c26df9fececb1311d842a9ab583aeaa.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2019/JanePhoto.png
// module id = 483
// module chunks = 0